import React from 'react'
import { Link } from 'react-router-dom'
import { Form, Icon, Input, Button, Row, Col } from 'antd';


class Randomize extends React.Component {
    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['weight'] = values['weight'] + 'kg'
                this.props.handleSubmit(values)
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading } = this.props;

        return (
            <Row type='flex' justify='center'>
                <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                    <h2> Randomize </h2>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item>
                            {getFieldDecorator('site', {
                                rules: [{
                                    required: true,
                                    message: 'Please input site id'
                                }],
                            })(
                                <Input
                                    prefix={<Icon type="medicine-box" style={{color: '#FAFAFA'}}/>}
                                    placeholder="Site ID"
                                    autoFocus
                                    allowClear
                                    size="large"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('user', {
                                rules: [{
                                    required: true,
                                    message: 'Please input user id'
                                }],
                            })(
                                <Input
                                    prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                                    placeholder="User ID"
                                    allowClear
                                    size="large"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('weight', {
                                rules: [{
                                    required: true,
                                    message: 'Please input weight'
                                }]
                            })(
                                <Input
                                    prefix={<Icon type="skin" style={{color: '#FAFAFA'}}/>}
                                    placeholder="Weight"
                                    allowClear
                                    addonAfter="kg"
                                    size="large"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('confirm', {
                                rules: [{
                                    required: true,
                                    message: 'Is the above information correct?'
                                }],
                            })(
                              <label>
                                <h5>
                                Is the above information correct?
                                </h5>
                                  <select id="confirm" name="confirm" size="large" className="ant-input ant-input-lg">
                                    <option value="">Is the above information correct?</option>
                                    <option value="yes">Yes</option>
                                  </select>
                              </label>
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button size='large' loading={loading} type="primary" htmlType="submit" className='btn-submit'>
                              {loading ? 'Randomization in progress. Please wait ...' : 'Randomize'}
                            </Button>
                        </Form.Item>
                    </Form>
                      <p>&nbsp;</p>
                      <h5>OR <br /> select one of the following options:</h5>

                      <ul>
                        <li><Link to='/' style={{ color: '#FAFAFA', width: '12rem' }} className='menu-item'> Home </Link></li>
                        <li><Link to='/patient-information-sheet' style={{ color: '#FAFAFA' }} className='menu-item'> Patient Information Sheet </Link></li>
                      </ul>


                </Col>
            </Row>
        )
    }
}


const RondomizeForm = Form.create()(Randomize);

export default RondomizeForm;



// WEBPACK FOOTER //
// ./src/components/Randomize/Randomize.js